<template>
  <section class="pricing-section text-center" id="pricing">
    <div class="container">
      <div class="row">
        <div class="col-md-10 col-lg-8 mx-auto text-center">
          <h2 class="text-white mb-5">{{ t('pricing.heading') }}</h2>
          <p class="mb-0 text-white-50 text-center" v-html="t('pricing.body')"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()
</script>